import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { forgotPasswordRequest } from 'api/aaaService';
import { makeAutoObservable } from 'mobx';
import { RootStore } from 'store/rootStore';

interface FormFields extends DefaultFormFields {
  email: FormControl<string>;
}

export default class ForgotPasswordStore {
  rootStore: RootStore;
  loading = false;
  forgotPasswordForm: FormController<FormFields>;
  showResetPasswordError = false;
  showPasswordRecoveryModal = false;

  setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  setShowPasswordRecoveryModal(status: boolean): void {
    this.showPasswordRecoveryModal = status;
  }

  setShowResetPasswordError(errorStatus: boolean): void {
    this.showResetPasswordError = errorStatus;
  }

  async forgotPassword(): Promise<void> {
    this.setShowResetPasswordError(false);

    this.setLoading(true);
    const res = await this.rootStore.requestProcessor.processRequest<string, { email: string }>(forgotPasswordRequest, {
      email: this.forgotPasswordForm.fields.email.value,
    });
    if (res?.status === 200) {
      this.setShowPasswordRecoveryModal(true);
    } else {
      this.setShowResetPasswordError(true);
    }
    this.setLoading(false);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    // Field is not optional, but required validations should not be shown for empty field
    this.forgotPasswordForm = new FormController({
      email: new FormControl<string>('', { validations: ['isEmailValid'], optional: true }),
    });
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
